export default __webpack_public_path__ + "7ddcafd14fa8644081feecc906e84d84.svg";